<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.form_placeholder_search_ecom_amz_file') ||
                  '原始文件名/店铺名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('uploadFile')"
              v-if="allow('U')"
            >
              <b-icon-upload></b-icon-upload>
              {{ $l('INDEX.btn_upload') || '上传' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="130px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_label_originalFileName') || '原始文件名'"
            >
              <el-input
                v-model.trim="form.originalFileName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.form_label_store') || '店铺'">
              <dict-select
                v-model="form.listStoreCode"
                url="/ecom/amz/store/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.table_label_uploadBy') || '上传人'">
              <dict-select
                v-model="form.listCreated"
                url="/master/common/dict/baseUserSelect"
                 :placeholder="$l('INDEX.tips_select_data') ||'请选择'"
                size="small"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_label_processFlag') || '文件处理标记'"
            >
              <el-select
                v-model="form.listProcessFlag"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              >
                <el-option value="N" :label="$l('INDEX.form_label_unhandled') ||'未处理'"></el-option>
                <el-option value="Y" :label="$l('INDEX.form_label_processing_completed') ||'已处理完毕'"></el-option>
                <el-option value="F" :label="$l('INDEX.form_label_error_in_processed_file') ||'已处理文件有误'"></el-option>
                <el-option value="K" :label="$l('INDEX.form_label_not_processed_temporarily') ||'暂不处理'"></el-option>
                <el-option value="D" :label="$l('INDEX.form_label_delete_data') ||'删除数据'"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_label_processDate') || '文件处理时间'"
            >
              <el-col :span="11">
                <el-date-picker
                  v-model="form.processDatetimeStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.processDatetimeEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_label_uploadDate') || '上传时间'"
            >
              <el-col :span="11">
                <el-date-picker
                  v-model="form.creationTimeStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.creationTimeEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  listProcessFlag: ['N', 'Y', 'F', 'K'],
  listCreated: [],
}
import { mapState } from 'vuex'
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        const { userCode } = userInfo || {}
        this.form.listCreated = [userCode || '']
        this.query()
      },
      immediate: true,
    },
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
      const { userCode } = this.info || {}
      this.form.listCreated = [userCode || '']
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
